import { render, staticRenderFns } from "./ShiftSummaryItem.vue?vue&type=template&id=fc24ce46&"
import script from "./ShiftSummaryItem.vue?vue&type=script&lang=js&"
export * from "./ShiftSummaryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports